import type { DraftLead } from '@user/store/draftLeads/typings'

/**
 * Whether a pending lead is blocked from auto-review by missing required fields. The single
 * gating predicate shared by the banner, the card and the Review button.
 */
export function isAutoReviewBlocked(args: {
  flagEnabled: boolean
  lead: Pick<DraftLead, 'isMissingAutoReviewFields' | 'type'>
}): boolean {
  const { flagEnabled, lead } = args
  return flagEnabled && lead.isMissingAutoReviewFields && lead.type !== 'Manual'
}
